/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 16:59:05
 * @LastEditTime: 2022-05-11 17:04:40
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/PermissionDetail/Security/index.tsx
 */
import { Button } from '@/src/components/Antd';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import RemoveUserModal from '../../Components/RemoveUserModal';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from '../style.module.less';

const Security = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;

  const handleCancel = () => {
    setShowModal(false);
  };

  const handelRemoveUser = () => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('usersAndPermissions.detail.removeuser')}
      </ErrorModalTitle>,
    );
    setModalContent(<RemoveUserModal onCancel={handleCancel} />);
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      rightPart={''}
      title={getI18n('usersAndPermissions.detail.security')}>
      <div
        className={!disabled ? css.authentication : css.authenticationNoLine}>
        <p className={css.ownershipTitle}>
          {getI18n('usersAndPermissions.detail.securityDetailTitle')}
        </p>
        <span className={css.ownershipText}>
          {getI18n('usersAndPermissions.detail.securityDetailContent')}
        </span>
      </div>
      {!disabled && (
        <Button onClick={handelRemoveUser} danger ghost>
          {getI18n('usersAndPermissions.detail.removeuser')}
        </Button>
      )}
    </SectionWrapper>
  );
};

export default ModalHoc(Security);
